import gql from 'graphql-tag';
import { AssetFragment } from '@app/pages/cmms/graphql/assets.queries';

export const CreateAssetMutation = gql`
	mutation CreateAssetMutation($assets: [CreateAssetMutationInputObject]) {
		createAsset(assets: $assets) {
			success
			assets {
				...AssetFragment
			}
		}
	}
	${AssetFragment}
`;

export const DeleteAssetMutation = gql`
	mutation DeleteAssetMutation($pk: UUID!) {
		deleteAsset(pk: $pk) {
			success
		}
	}
`;

export const DeleteAssetsMutation = gql`
	mutation DeleteAssetsMutation($assets: [UUID]!) {
		deleteAssets(assets: $assets) {
			success
		}
	}
`;

export const EditAsset = gql`
	mutation EditAsset($asset: EditAssetMutationInputObject!) {
		editAsset(asset: $asset) {
			success
			asset {
				...AssetFragment
			}
		}
	}
	${AssetFragment}
`;

export const LinkAssetsObjects = gql`
	mutation LinkAssetsObjects(
		$assets: [UUID]!
		$classifications: [String]
		$files: [UUID]
		$incidents: [UUID]
		$location: UUID
		$requests: [UUID]
		$workOrders: [UUID]
	) {
		linkAssetsObjects(
			assets: $assets
			classifications: $classifications
			files: $files
			incidents: $incidents
			location: $location
			requests: $requests
			workOrders: $workOrders
		) {
			success
		}
	}
`;

export const UnlinkAssetObjects = gql`
	mutation UnlinkAssetObjects(
		$pk: UUID!
		$files: [UUID]
		$incidents: [UUID]
		$requests: [UUID]
		$workOrders: [UUID]
	) {
		unlinkAssetObjects(
			pk: $pk
			files: $files
			incidents: $incidents
			requests: $requests
			workOrders: $workOrders
		) {
			success
		}
	}
`;
